import { render, staticRenderFns } from "./Review.vue?vue&type=template&id=60a9996c&scoped=true&"
import script from "./Review.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Review.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a9996c",
  null
  
)

export default component.exports